import { useMemo } from 'react';
import { useAppSelector } from '../useReduxToolkit';
import { getNonOfflineMembers } from '../../features/realtime/realtime.selectors';
import { RealtimeRole } from '../../features/realtime/realtime.types';
import { AudioFile, callStartSoundToAudioFile } from '../useAudio';

/**
 * Default call start sound configuration (if no preference is set by Provider, `null`).
 */
export const DEFAULT_CALL_START_SOUND = {
  NAME: 'waitingfor',
  AUDIO_FILE: AudioFile.Waitingfor,
} as const;

/**
 * Hook to get the appropriate call start sound based on Provider's preference.
 *
 * The source of truth (user settings vs tenant settings) is determined by
 * `useRealtimeCallStartSoundSync`, which syncs the correct value to realtime state.
 */
export const useCallStartSound = (): AudioFile => {
  const members = useAppSelector(getNonOfflineMembers);

  const provider = members.find(
    (member) => member.identity.role === RealtimeRole.Provider,
  );

  const selectedAudioFile = useMemo(() => {
    const providerCallStartSound = provider?.state?.callStartSound;

    return (
      (providerCallStartSound &&
        callStartSoundToAudioFile[providerCallStartSound]) ||
      DEFAULT_CALL_START_SOUND.AUDIO_FILE
    );
  }, [provider?.state?.callStartSound]);

  return selectedAudioFile;
};
